import React, { Component } from 'react';
import FormWrapper from '../../../containers/Forms/FormWrapper';
import FormResetPassword from '../../../containers/Forms/FormResetPassword';
import { entityNames } from '../../../config/constants';

class Stage3 extends Component {
  componentDidMount() {
    const { fetchReset } = this.props;
    if (fetchReset) {
      fetchReset(entityNames.RESET_PASSWORD);
    }
  }

  render() {
    const { t, resetPassword } = this.props;
    return (
      <div className="reset-stage">
        <h2 className="reset-stage-title">{t('resetPassword:setNewPassword')}</h2>
        <FormWrapper
          entityName={entityNames.RESET_PASSWORD}
          entity={['password', 'confirmPassword']}
          onSubmit={resetPassword}
          noValidation={true}
        >
          <FormResetPassword />
        </FormWrapper>
      </div>
    );
  }
}

export default Stage3;
